<section class="pupil-task-exercise">
  <div class="task type-text pupil-task-exercise__wrapper">
    <div class="row" *ngIf="errorMessage">
      <div>{{errorMessage}}</div>
    </div>
    <div class="task-number">
      <h4 class="bluelight_txt">Задание {{ selectedExerciseIndex + 1 }}</h4>
    </div>
    <div class="pupil-task-exercise__text">
      <p class="condition-task text-left">
        <ng-katex *ngIf="isKatexFormat(exercise)" class="katex" [equation]="exercise.text"></ng-katex>
        <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" [paragraph]="exercise.text"></ng-katex-paragraph>
      </p>
      <table class="task" *ngIf="exercise.questions == null">
        <app-pupil-task-no-question
          [exercise]="exercise"
          [studentId]="studentId"
          [cardId]="cardId"
          (answered)="answered"
          (exerciseCompleted)="exerciseCompleted"
          (exerciseCorrect)="exerciseCompleted"
        >
        </app-pupil-task-no-question>
      </table>
      <div *ngIf="exercise.type !== 'task' && exercise.questions">
        <app-pupil-question
          *ngFor="let question of exercise.questions.slice(0, 1); let questIndex = index;"
          [question]="question"
          [exercise]="exercise"
          [questIndex]="questIndex"
          [studentId]="studentId"
          [cardId]="cardId"
          (questionAnsweredCorrectly)="isQuestionCorrect($event)"
          (questionAnswer)="emitAnswer($event)"
        ></app-pupil-question>
      </div>
      <div *ngIf="exercise.type === 'task' && exercise.questions">
        <app-pupil-task-question
          *ngFor="let question of exercise.questions.slice(0, 1); let questIndex = index;"
          [question]="question"
          [exercise]="exercise"
          [questIndex]="questIndex"
          [studentId]="studentId"
          [cardId]="cardId"
          [answer]="getQuestionAnswer(question)"
          (questionAnsweredCorrectly)="isQuestionCorrect($event)"
          (questionAnswer)="emitAnswer($event)"
        ></app-pupil-task-question>
      </div>
    </div>
  </div>
</section>
